import React from 'react'
import moment from 'moment'
import cn from 'classnames'

import FeedReactions from '../../FeedReactions'
import StreakIcon from 'app/components/SVGS/StreakIcon'
import AchievementIcon from 'app/components/SVGS/AchievementIcon'

import './styles.scss'
export const bc = 'feed-recent-achievement-item'

const FeedRecentAchievementItem = ({
  t,
  identity,
  user,
  timestamp,
  event,
  setReaction,
  reactions,
  updateReaction,
  showReactions,
  index,
  handleSetFeedEventLikeOld,
  isNewEvent,
}) => {
  const identityData = identity.toJS()
  const userReaction = reactions && reactions.find(item => item.user.id === identityData.id)
  const isStreakAchievement = event.streak
  return (
    <div className={cn(bc, { [`${bc}__new`]: isNewEvent })} onAnimationEnd={() => handleSetFeedEventLikeOld(index)}>
      <div className={`${bc}__wrapper`}>
        <div className={`${bc}__image`}>{isStreakAchievement ? <StreakIcon /> : <AchievementIcon />}</div>
        <div className={`${bc}__user`}>
          <div className={`${bc}__title`}>
            {t('Congratulate')} {user.firstName}
          </div>
          <div className={`${bc}__message`}>
            {isStreakAchievement
              ? `${event.streak} ${t('days streak!')}`
              : `${event.completedCount} ${t('completed activities!')}`}
          </div>
        </div>
        <div className={`${bc}__date`}>{moment(timestamp).fromNow()}</div>
      </div>
      {showReactions && (
        <div className={`${bc}__reactions`}>
          <FeedReactions
            reactions={reactions}
            hasReacted={Boolean(userReaction)}
            setReaction={emoji => {
              userReaction ? updateReaction(userReaction, emoji) : setReaction(emoji, event.id, identityData)
            }}
            likeActionEnabled={user.id !== identityData.id}
          />
        </div>
      )}
    </div>
  )
}

export default FeedRecentAchievementItem
